import {createStore} from 'vuex'
import axiosApi from "@/utils/axiosApi";
import {Base64} from "js-base64";
import {couponConf} from "@/utils/config";

export default createStore({
    state: {
        account: {},
        order: {},
        coupon: "",
        orderFrom: "def",
        product: {}
    },
    getters: {},
    mutations: {
        setOrder(state, value) {
            this.state.order = value
        },
        removeAccount() {
            window.sessionStorage.removeItem('diff_account')
            this.state.account = {}
        },
        setCoupon(state, value) {
            window.sessionStorage.setItem("coupon", value)
            this.state.coupon = value
        },
        getCoupon() {
            this.state.coupon = window.sessionStorage.getItem("coupon")
        },
        getOrderFrom(){
            this.state.orderFrom = window.sessionStorage.getItem("orderFrom") || "def"
        },
        setOrderFrom(state, value) {
            window.sessionStorage.setItem("orderFrom", value)
            this.state.orderFrom = value
        },
        setCouponIts(state,value){
            window.sessionStorage.setItem("product",JSON.stringify(value))
            this.state.product = value
        },
        getCouponIts(){
            let product = window.sessionStorage.getItem("product")
            if (!product) {
                this.state.product = {}
                return;
            }
            this.state.product = JSON.parse(product)
        }
    },
    actions: {
        setAccounts(state, value) {
            window.sessionStorage.setItem("diff_account", JSON.stringify(value))
            this.state.account = value
        },
        getAccounts() {
            let accounts = window.sessionStorage.getItem("diff_account")
            if (!accounts) {
                this.state.account = {}
                return;
            }
            accounts = JSON.parse(accounts)
            let cop = couponConf[this.state.coupon]?.login || 'scal'
            let methods = {
                encode: "site",
                method: "user/check_login",
                body: {
                    cust_id: accounts.cust_id,
                    token: accounts.token
                }
            }
            if (cop === 'xm_air') {
                methods.method = "user/xm_user_info"
                methods.body = {access_token: accounts.access_token, user_id: accounts.user_id}
                methods.score_type = "xm_air"
            }
            //校验会员登录
            new axiosApi(methods).send((res) => {
                if (res.message.code !== "000") {
                    window.sessionStorage.removeItem("diff_account")
                    this.state.account = {}
                    return
                }
                let dat = res.data
                dat.phoneNumber = /^1[2-9]\d{9}$/.test(dat.phoneNumber) ? dat.phoneNumber : Base64.decode(dat.phoneNumber)
                if (cop === 'xm_air') {
                    dat.access_token = accounts.access_token
                    dat.user_id = accounts.user_id
                }
                window.sessionStorage.setItem("diff_account", JSON.stringify(dat));
                this.state.account = dat
                return dat;
            }, () => {
                window.sessionStorage.removeItem("diff_account")
                this.state.account = {}
                return false
            })
        }
    },
    modules: {}
})
